export const residenceTypes = [
  { value: 'villa', label: 'Villa/parcelhus' },
  { value: 'townhouse', label: 'Rækkehus' },
  { value: 'apartment', label: 'Lejlighed' },
  { value: 'summerhouse', label: 'Fritidshus' },
];
